import { render, staticRenderFns } from "./CargoEditor.vue?vue&type=template&id=79093788&"
import script from "./CargoEditor.vue?vue&type=script&lang=js&"
export * from "./CargoEditor.vue?vue&type=script&lang=js&"
import style0 from "./CargoEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79093788')) {
      api.createRecord('79093788', component.options)
    } else {
      api.reload('79093788', component.options)
    }
    module.hot.accept("./CargoEditor.vue?vue&type=template&id=79093788&", function () {
      api.rerender('79093788', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/CargoEditor.vue"
export default component.exports